import { useEffect, useState } from "react";
// redux
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
// route
import { useNavigate } from "react-router";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// styled components
import { notification } from "antd";
import { useEncrypt } from "./useEncrypt";
import getStorageUser from "../middlewares/GetStorageUser"
import { ObjNotificaciones } from "../config/notificaciones";

export const useSeleccionarCategoria = () => {
  // redux

  const [openModalError, setOpenModalError] = useState(false);
  const [onCategorias, setOnCategorias] = useState(false);
  const [loading, setLoading] = useState(false);
  const { tipo_participante } = useSelector(
    (state: RootState) => state.participantes
  );

  // route
  const navigate = useNavigate();
  //   state
  const [categoria, setCategoria] = useState<any>(null);
  const [user, setUser] = useState<any>({});

  const { decrypt } = useEncrypt();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      getUser();
    }
  }, []);

  const onAceptar = () => {
    setOnCategorias(false);
    return setOpenModalError(false);
  };

  //   notificaciones
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };

  const getUser = async () => {
    try {
      const user = getStorageUser()
      return setUser(user);
    } catch (error) { }
  };
  //   function
  const cambioCategorias = async (value: string) => {
    return setCategoria(value);
  };

  const guardarCategoriaPostulacion = async (convocatoria: any, guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    let obj = {
      documento: user.documento,
      convocatoria_id: convocatoria.idconvocatorias,
      linea_convocatoria: convocatoria.linea_convocatoria,
      categoria_linea_convocatoria: categoria,
      tipo_participante,
      id_postulacion
    };

    if (categoria === undefined || categoria === null) {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor seleccione una categoria",
        placement: "bottomRight",
      });
    } else {
      let resp = await apiParticipantes.verificarInscripcionPostulacion(obj);

      if (!resp.ok) {
        setOpenModalError(true);
        setOnCategorias(true);
        return resp;
      } else {
        let categoriafiltrado = convocatoria.categoria_linea_convocatoria.filter(
          (data: any) => data.value === categoria
        );

        if (categoriafiltrado.length > 0) {
          try {
            setLoading(true);
            await apiParticipantes.actualizarCategoriaLineaConvocatoriaPropuesta(id_postulacion,
              categoria
            );
            setLoading(false);
            if (guardar) {
              await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
              ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
              return navigate("/Usuario");
            } else {
              return navigate("/usuario/Documentosadministrativos");
            }
          } catch (error) {
            setLoading(false);
            return console.error(error);
          }
        } else {
          return openNotification({
            titulo: "Error",
            descripcion: "Por favor seleccione una categoria",
            placement: "bottomRight",
          });
        }
      }
    }
  };

  return {
    categoria,
    cambioCategorias,
    guardarCategoriaPostulacion,
    setCategoria,
    setOpenModalError,
    openModalError,
    onCategorias,
    setOnCategorias,
    onAceptar,
    loading,
  };
};
